import React from 'react';
import { withTranslation } from 'react-i18next';
import OpenInNewIcon from 'mdi-react/OpenInNewIcon';

const OpenArticleOnBlog = ({t, onClick}) => (
    <span className="button-tag"><button
        className="draft_table-btn"
        title={t('posts.articles.tooltips.open_article_on_blog')}
        type="button"
        onClick={onClick}><OpenInNewIcon/></button></span>
)

export default withTranslation('dashboard')(OpenArticleOnBlog);
